import PropTypes from 'prop-types'
import { CONTACT_OPTIONS } from '../constants'

export const SERVER_DATA = {
  pageProps: PropTypes.object.isRequired,
  reqContextData: PropTypes.object.isRequired,
}

export const HELP_CHANNEL_DATA = {
  iconName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  target: PropTypes.string,
  url: PropTypes.string.isRequired,
}

export const MORE_WAYS_OF_HELP_DATA = {
  helpChannels: PropTypes.arrayOf(PropTypes.shape(HELP_CHANNEL_DATA)),
}

export const ARTICLE_CONTENT_DATA = {
  articleContent: PropTypes.shape({
    articleContent: PropTypes.string.isRequired,
    articleTitle: PropTypes.string.isRequired,
    ecmComponentIds: PropTypes.string,
    ecmDocId: PropTypes.string,
  }),
  articleId: PropTypes.string.isRequired,
  exp: PropTypes.string.isRequired,
}

export const HERO_MODULE_DATA = {
  name: PropTypes.string,
  searchQuery: PropTypes.string,
  appliedFilter: PropTypes.object,
}

export const ARTICLE_LINK_DATA = {
  articleId: PropTypes.string.isRequired,
  articleTitle: PropTypes.string.isRequired,
  excerpt: PropTypes.string,
  usage: PropTypes.number,
  rank: PropTypes.number,
  views: PropTypes.number,
  channel: PropTypes.string.isRequired,
  target: PropTypes.string,
  link: PropTypes.string,
}
export const ARTICLE_LINKS_DATA = {
  articlesData: PropTypes.arrayOf(PropTypes.shape(ARTICLE_LINK_DATA)),
  componentName: PropTypes.string.isRequired,
  articleId: PropTypes.string.isRequired,
}

export const TOPIC_TREE_DATA = {
  topicId: PropTypes.string,
  subTopicId: PropTypes.string,
  topicName: PropTypes.string,
  subTopicName: PropTypes.string,
}

export const TOPIC_TREE_COMPLETE_DATA = {
  breadCrumbPath: PropTypes.string,
  topicTreeData: PropTypes.arrayOf(PropTypes.shape(TOPIC_TREE_DATA)),
  pageName: PropTypes.string,
}

export const RECOMMENDED_ARTICLE_DATA = {
  articleId: PropTypes.string.isRequired,
  articleTitle: PropTypes.string.isRequired,
  channel: PropTypes.string,
  excerpt: PropTypes.string,
  rank: PropTypes.number,
  topicId: PropTypes.string,
  topicName: PropTypes.string,
  usage: PropTypes.number,
}

export const RECOMMENDED_SOLUTIONS_DATA = {
  recommendedSolutionsData: PropTypes.arrayOf(
    PropTypes.shape(RECOMMENDED_ARTICLE_DATA),
  ),
  deviceType: PropTypes.string.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
}

export const BREADCRUMBS_DATA = {
  breadCrumbPath: PropTypes.string,
  breadCrumbTitle: PropTypes.string,
}

export const ARTICLE_FEEDBACK_DATA = {
  articleId: PropTypes.string,
  helpComponentIds: PropTypes.string,
}

export const TAB_INFO = {
  id: PropTypes.string.isRequired,
  tabProps: PropTypes.object.isRequired,
}
export const TAB_SWITCHER_DATA = {
  name: PropTypes.string.isRequired,
  tabsInfo: PropTypes.arrayOf(PropTypes.shape(TAB_INFO)).isRequired,
  renderTabContent: PropTypes.func.isRequired,
  articleId: PropTypes.string.isRequired,
}

export const ARTICLE_CONTENT_TABS_DATA = {
  articleContent: PropTypes.shape({
    articleTitle: PropTypes.string.isRequired,
    personalContent: PropTypes.string,
    businessContent: PropTypes.string,
    ecmComponentIds: PropTypes.string,
    ecmDocId: PropTypes.string,
  }),
  articleId: PropTypes.string.isRequired,
  accountType: PropTypes.string.isRequired,
}

export const ALERTS_DATA = {
  pageName: PropTypes.string.isRequired,
}

export const TRACKER_DATA = {
  pageName: PropTypes.string.isRequired,
}

export const COOKIE_BANNER_DATA = {
  js: PropTypes.string,
  css: PropTypes.string,
  html: PropTypes.string,
}

const REQ_CONTEXT_DATA = {
  isLoggedIn: PropTypes.bool.isRequired,
  userExperience: PropTypes.string.isRequired,
}

const CONSUMER_NAV_DATA = {
  footerHtml: PropTypes.string,
}

const MERCHANT_NAV_DATA = {
  footerEl: PropTypes.string,
}

export const NAVIGATION_DATA = {
  consumer: PropTypes.shape(CONSUMER_NAV_DATA),
  merchant: PropTypes.shape(MERCHANT_NAV_DATA),
}

export const LAYOUT_FOOTER_DATA = {
  navigation: PropTypes.string,
  reqContextData: PropTypes.shape(REQ_CONTEXT_DATA),
}

export const FPTI_SETUP_DATA = {
  nonce: PropTypes.string,
  context: PropTypes.object,
  tracking: PropTypes.shape({
    addClientSideFptiData: PropTypes.func,
    doAnalytics: PropTypes.func,
  }),
  serverData: PropTypes.shape(SERVER_DATA),
}

export const LAYOUT_SERVER_DATA = {
  serverData: PropTypes.shape(SERVER_DATA),
}

export const ARTICLE_FEEDBACK_REASON_DATA = {
  onSubmit: PropTypes.func.isRequired,
}

export const HEADER_FOOTER_DATA = {
  isLoggedIn: PropTypes.bool.isRequired,
  serverData: PropTypes.shape(SERVER_DATA),
  reqContextData: PropTypes.shape(REQ_CONTEXT_DATA),
}

export const INTENT_CHATBOT_CONTAINER_DATA = {
  articleTitle: PropTypes.string,
  articleId: PropTypes.string,
  config: PropTypes.shape({
    intentId: PropTypes.string,
    isEnabled: PropTypes.bool,
  }),
}

export const INTENT_CHATBOT_PROMPT_DATA = {
  articleTitle: PropTypes.string,
  articleId: PropTypes.string,
  config: PropTypes.shape({
    intentId: PropTypes.string,
    isEnabled: PropTypes.bool,
  }),
  chatEligibilityData: PropTypes.shape({
    async: PropTypes.bool,
    displayChatPrompt: PropTypes.bool,
  }),
}

export const PERSONAL_EXP_DATA = {
  renderWidgets: PropTypes.func.isRequired,
}

export const BUSINESS_EXP_DATA = {
  renderWidgets: PropTypes.func.isRequired,
}

export const TECHNICAL_EXP_DATA = {
  renderWidgets: PropTypes.func.isRequired,
}

export const GEN_AI_SUMMARY_DATA = {
  searchQuery: PropTypes.string.isRequired,
  csrf: PropTypes.string.isRequired,
}

const FILTER_DATA = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}

export const SEARCH_FILTER_DATA = {
  appliedFilter: PropTypes.shape(FILTER_DATA),
  applyFilter: PropTypes.func.isRequired,
  docTypes: PropTypes.arrayOf(PropTypes.shape(FILTER_DATA)).isRequired,
}

export const CONTACT_CHANNEL_DATA = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export const CONTACT_CHANNELS_DATA = {
  channels: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      priority: PropTypes.number.isRequired,
      availability_decision: PropTypes.string.isRequired,
      availability_decision_reason: PropTypes.string,
    }),
  ),
  urls: PropTypes.shape({
    [CONTACT_OPTIONS.COMMUNITY]: PropTypes.string.isRequired,
    [CONTACT_OPTIONS.RES_CENTER]: PropTypes.string.isRequired,
  }).isRequired,
  chatEntryPointName: PropTypes.string.isRequired,
  topicRefId: PropTypes.string,
}

export const STEPUP_DIALOG_DATA = {
  isDialog: PropTypes.bool.isRequired,
  actionHandler: PropTypes.func.isRequired,
  contactChannel: PropTypes.string.isRequired,
  stepUpCallback: PropTypes.func.isRequired,
  topicRefId: PropTypes.string.isRequired,
}

export const STEPUP_DATA = {
  isStepUp: PropTypes.bool.isRequired,
  contactChannel: PropTypes.string,
  stepUpCallback: PropTypes.func.isRequired,
  topicRefId: PropTypes.string,
}

export const MESSAGE_US_LOGIN_DIALOG_DATA = {
  isDialogOpen: PropTypes.bool.isRequired,
  onLoginClick: PropTypes.func,
  recoverPasssword: PropTypes.func,
  onClose: PropTypes.func,
}

export const CALL_US_LOGIN_DIALOG_DATA = {
  isOpen: PropTypes.bool.isRequired,
  onLoginClick: PropTypes.func,
  recoverPasssword: PropTypes.func,
  onLoginDialogClose: PropTypes.func,
}

export const TOPIC_TILE_DATA = {
  topic: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  onClick: PropTypes.func.isRequired,
}
